import env from './EnvironmentConfig'

export const APP_NAME = 'Ttivos'
// @ts-ignore
export const API_BASE_URL = env.API_ENDPOINT_URL
export const APP_PREFIX_PATH = ''
export const AUTH_PREFIX_PATH = '/auth'
export const AUTHLAB_PREFIX_PATH = '/auth-lab'
export const ADMIN_PREFIX_PATH = '/admin'
